// CRM 2.0 · M12-F4 · Agreement Sign › Scan any QR: the camera opens at once; any agreement QR (a page or the copy QR
// on page 1) shows its information without choosing an agreement first. When the copy is with me to sign, "Start
// signing" opens it; otherwise "Scan another".
import React, { useCallback, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import cls from "./Crm2Verify.module.css";
import QrCamera from "./QrCamera";
import ScanResult from "./ScanResult";
import { readAnyQr } from "../../Services/Crm2Verify";

function GlobalScanner() {
  const navigate = useNavigate();
  const [scan, setScan] = useState(null);
  const [toast, setToast] = useState(null);
  const reading = useRef(false);
  const toastTimer = useRef(null);

  const onRead = useCallback(async (text) => {
    if (reading.current) return;
    reading.current = true;
    try {
      setScan(await readAnyQr(text));
    } catch (e) {
      setToast(e.message);
      clearTimeout(toastTimer.current);
      toastTimer.current = setTimeout(() => setToast(null), 3000);
    } finally {
      reading.current = false;
    }
  }, []);

  return (
    <div className={cls.scanner}>
      <div className={cls.topBar}>
        <div className={cls.topInfo}>
          <p className={cls.topUnit}>Scan any QR</p>
          <p className={cls.topSub}>A page QR, or the copy QR on the top sheet</p>
        </div>
        <button className={cls.chipBtn} onClick={() => navigate("/crm2/verify-agreements")}>Close</button>
      </div>
      {/* the pop-up opens below the top bar */}
      <div className={cls.stage}>
      <QrCamera paused={!!scan} onRead={onRead} hint="Point the camera at a QR on the agreement" />
      {toast && <div className={cls.toast} role="status">{toast}</div>}
      {scan && <div className={cls.backdrop} aria-hidden="true" />}
      {scan && (
        <div className={cls.sheet} role="dialog" aria-label={scan.title}>
          <div className={cls.handle} aria-hidden="true" />
          <div className={cls.sheetBody}><ScanResult scan={scan} /></div>
          <div className={cls.sheetFoot}>
            {scan.canSign ? (
              <div className={cls.footRow}>
                <button className={cls.btn} onClick={() => setScan(null)}>Scan another</button>
                <button className={`${cls.btn} ${cls.primary}`} onClick={() => navigate(`/crm2/verify-agreements/${scan.crm2AgreementCopyId}`)}>Start signing</button>
              </div>
            ) : (
              <button className={`${cls.btn} ${cls.primary} ${cls.wide}`} onClick={() => setScan(null)}>Scan another</button>
            )}
          </div>
        </div>
      )}
      </div>
    </div>
  );
}

export default GlobalScanner;
